"use client";

import { useEffect, useState } from "react";
import { cn } from "@marketing-sites/utils/cn";
import { Carousel } from "../../primitives";

function ArrowIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 16 16" fill="none" aria-hidden>
      <path
        d="M6 3.5 10.5 8 6 12.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const arrowButtonClassName =
  "border-current/20 hover:bg-current/5 flex size-9 cursor-pointer items-center justify-center rounded-md border transition-opacity disabled:cursor-default disabled:opacity-30";

/** Must render inside <Carousel.Root>. Hides itself when every card fits. */
export function SpeakerArrows({ className }: { className?: string }) {
  const { emblaApi } = Carousel.useCarousel();
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(false);

  useEffect(() => {
    if (!emblaApi) return;
    const update = () => {
      setCanPrev(emblaApi.canScrollPrev());
      setCanNext(emblaApi.canScrollNext());
    };
    update();
    emblaApi.on("select", update).on("reInit", update);
    return () => {
      emblaApi.off("select", update).off("reInit", update);
    };
  }, [emblaApi]);

  if (!canPrev && !canNext) return null;

  return (
    <div className={cn("flex shrink-0 gap-x-2", className)}>
      <button
        type="button"
        aria-label="Previous speakers"
        onClick={() => emblaApi?.scrollPrev()}
        disabled={!canPrev}
        className={arrowButtonClassName}
      >
        <ArrowIcon className="size-4 rotate-180" />
      </button>
      <button
        type="button"
        aria-label="Next speakers"
        onClick={() => emblaApi?.scrollNext()}
        disabled={!canNext}
        className={arrowButtonClassName}
      >
        <ArrowIcon className="size-4" />
      </button>
    </div>
  );
}
